import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import SendNotification from "./sendNotification";
import SendEmailNotification from "./sendEmailNotification";
import { cancelNotificationTask, createNotificationTask, createEmailNotificationTask, getNotificationTask, searchNotifications, searchNotificationsByUserId } from "../../action/notification";
import FindNotification from "./findNotification";
import {
  Box,
  Divider,
} from "@mui/material";
import { SectionHeading, LabelText, ValueText } from "../Common/Typography/AppTypography";
import Dialog from "../Common/Dailog/Dailog";
import { getNotificationPermission, notificationStatusMoreHeaders } from "./notificationConstant";
import { getFormatedJSON } from "../../utils/general";
import AppButton from "../Common/Button/Button";
import AppTabs from "../Common/Tabs/AppTabs";
import DataTable from "../Common/DataTable/DataTable";

const NotificationManagement = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    notificationStore,
    getNotificationTask,
    createNotificationTask,
    createEmailNotificationTask,
    cancelNotificationTask,
    searchNotificationsByUserId,
    searchNotifications,
    userData,
    tenantData,
    userRoles,
    userLevel,
}) => {
    const [activeTab, setActiveTab] = React.useState(0)
    const [dialog, setDialog] = useState(false);
    const [dialogTab, setDialogTab] = useState(0);
    const [dialogContents, setDialogContents] = useState({ title: "", data: {}, content: "" })

    const tabs = [
        { label: "Push Notification", permission: 'sendNotification' },
        { label: "Email Notification", permission: 'sendNotification' },
        { label: "Search Notification", permission: 'getNotificationTask' },
    ]
    const [availableTabs, setAvailableTabs] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

    useEffect(() => {
        const visibleTabs = tabs?.filter(t => {
            return getNotificationPermission(userRoles, t?.permission)
        })?.map(t => t?.label)
        setAvailableTabs(visibleTabs)
        setSelectedTab(visibleTabs[0])
    }, [userRoles])

    const notificationDetailColumns = Object.keys(notificationStatusMoreHeaders).map((key) => ({
        key,
        label: notificationStatusMoreHeaders[key]?.label,
        minWidth: 180,
        headerCellSx: {
            backgroundColor: "background.paper",
            fontWeight: 600,
        },
        render: (value) => {
            const textValue = value ?? "-";
            const isLong = String(textValue).length > 200;

            return (
                <Box
                    sx={{
                        whiteSpace: isLong ? "normal" : "nowrap",
                        wordBreak: isLong ? "break-word" : "normal",
                    }}
                >
                    {textValue}
                </Box>
            );
        },
    }));

    const notificationDetailRows = dialogContents?.data
        ? [{
            rowId: dialogContents?.data?.fullTaskId || dialogContents?.data?.fullUniqueId || "notification-detail-row",
            ...Object.keys(notificationStatusMoreHeaders).reduce((acc, key) => {
                acc[key] = Object.prototype.hasOwnProperty.call(dialogContents?.data || {}, key)
                    ? dialogContents.data[key]
                    : "-";
                return acc;
            }, {})
        }]
        : [];

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            {(!getNotificationPermission(userRoles, 'sendNotification') && !(getNotificationPermission(userRoles, 'getNotificationTask') || getNotificationPermission(userRoles, 'getNotificationList'))) ? (
                <Box sx={{ py: 2 }}>
                  <SectionHeading>Insufficient Permission</SectionHeading>
                </Box>
            )
                :
                <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, marginTop: 0, boxSizing: "border-box" }}>
                    <AppTabs
                        value={activeTab}
                        onChange={(e, newValue) => {
                            setActiveTab(newValue)
                            setSelectedTab(availableTabs[newValue])
                        }}
                        tabs={availableTabs?.map((label) => ({ label }))}
                        variant="scrollable"
                        scrollButtons="auto"
                        style={{ marginTop: 0 }}
                        tabMinWidth="auto"
                    />
                    {
                        selectedTab === "Push Notification" ?
                            <SendNotification
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                notificationStore={notificationStore}
                                createNotificationTask={createNotificationTask}
                                getNotificationTask={getNotificationTask}
                                setDialog={setDialog}
                                setDialogContents={setDialogContents}
                                setDialogTab={setDialogTab}
                                userLevel={userLevel}
                            ></SendNotification>
                            : selectedTab === "Email Notification" ?
                            <SendEmailNotification
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                notificationStore={notificationStore}
                                createEmailNotificationTask={createEmailNotificationTask}
                                getNotificationTask={getNotificationTask}
                                setDialog={setDialog}
                                setDialogContents={setDialogContents}
                                setDialogTab={setDialogTab}
                            ></SendEmailNotification>
                            :
                            <FindNotification
                                notificationData={notificationStore}
                                getNotificationTask={getNotificationTask}
                                searchNotificationsByUserId={searchNotificationsByUserId}
                                allowedCountries={allowedCountries}
                                searchNotifications={searchNotifications}
                                setAlert={setAlert}
                                userData={userData}
                                tenantData={tenantData}
                                setDialog={setDialog}
                                setDialogContents={setDialogContents}
                                setDialogTab={setDialogTab}
                                userRoles={userRoles}
                            ></FindNotification>
                    }
                </Box>}
            <Dialog
                open={dialog}
                onClose={() => setDialog(false)}
                title={dialogContents?.title}
                maxWidth="md"
                fullWidth
                showCloseButton
                sx={{ zIndex: "2400 !important" }}
                PaperProps={{
                    sx: {
                        // Prevent overlap with header/hamburger on small screens (header ~64px + spacing)
                        marginTop: { xs: "72px", sm: "72px", md: 0 },
                        maxHeight: { xs: "calc(100vh - 88px)", sm: "calc(100vh - 88px)", md: "90vh" },
                    },
                }}
                titleSx={{ backgroundColor: "#f4f4f4", fontSize: "16px !important" }}
                contentSx={{ overflowY: "visible" }}
                actions={
                    dialogContents?.content?.toLowerCase()?.includes("notificationdetails")
                        ? [{ label: "Close", variant: "ghost", onClick: () => setDialog(false) }]
                        : [
                            { label: "Cancel", variant: "ghost", onClick: () => setDialog(false) },
                            {
                                label: "Confirm",
                                variant: "primary",
                                onClick: () => {
                                    setDialog(false);
                                    cancelNotificationTask(dialogContents?.data?.fullTaskId, () => {
                                        getNotificationTask(dialogContents?.data?.fullTaskId);
                                    });
                                },
                            },
                          ]
                }
            >
                {dialogContents?.content?.toLowerCase()?.includes("notificationdetails") ? (
                    <Box sx={{ width: "100%" }}>
                        <AppTabs
                            value={dialogTab}
                            onChange={(e, newValue) => setDialogTab(newValue)}
                            tabs={[{ label: "Details" }, { label: "JSON" }]}
                            tabMinWidth="auto"
                        />
                        <Divider sx={{ mb: 2 }} />
                        <Box sx={{ maxHeight: "55vh", overflowY: "auto" }}>
                            {dialogTab === 0 ? (
                                <Box>
                                    {dialogContents?.data && dialogContents?.content !== "userNotificationDetails" && (
                                        <DataTable
                                            columns={notificationDetailColumns}
                                            data={notificationDetailRows}
                                            rowKey="rowId"
                                            minWidth="100%"
                                            striped={false}
                                            hoverEffect={false}
                                            tableContainerSx={{ boxShadow: "none", borderRadius: 0, mb: 2 }}
                                            msgForDisplay="No Data found"
                                        />
                                    )}
                                    {dialogContents?.data && (
                                        <Box sx={{ mt: 1 }}>
                                            {(dialogContents.data.fullTaskId || dialogContents.data.fullUniqueId) && (
                                                <Box sx={{ mb: 1.5 }}>
                                                    <LabelText sx={{ fontWeight: 400, color: "text.secondary" }}>
                                                        {dialogContents.data.fullTaskId ? "Task ID" : "Unique ID"}
                                                    </LabelText>
                                                    <ValueText sx={{ wordBreak: "break-all" }}>
                                                        {dialogContents.data.fullTaskId || dialogContents.data.fullUniqueId}
                                                    </ValueText>
                                                </Box>
                                            )}
                                            <LabelText sx={{ fontWeight: 400, color: "text.secondary", mb: 0.5 }}>
                                                Message
                                            </LabelText>
                                            <Box>{getFormatedJSON(dialogContents.data.msg)}</Box>
                                        </Box>
                                    )}
                                </Box>
                            ) : (
                                <Box>{getFormatedJSON(dialogContents?.data?.payload)}</Box>
                            )}
                        </Box>
                    </Box>
                ) : (
                    <LabelText>
                        {`Are you sure you want to cancel the notification with task ID ${dialogContents?.data?.fullTaskId} ?`}
                    </LabelText>
                )}
            </Dialog>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    allowedCountries: state.auth.allowedCountries,
    userLevel: state.auth.userLevel,
    userRoles: state.auth.roles,
    notificationStore: state.notification,
    userData: state.user,
    tenantData: state?.tenant?.tenantInfo
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    createNotificationTask: (requestData) => dispatch(createNotificationTask(requestData)),
    createEmailNotificationTask: (requestData) => dispatch(createEmailNotificationTask(requestData)),
    getNotificationTask: (taskId, action = "updateGetNotification") => dispatch(getNotificationTask(taskId, action)),
    searchNotificationsByUserId: (userId, pgIndex, severity = null, pgSize) =>
        dispatch(searchNotificationsByUserId(userId, pgIndex, severity, pgSize)),
    searchNotifications: (searchBy, searchStr, pgIndex, tenantId, pgSize) =>
        dispatch(searchNotifications(searchBy, searchStr, pgIndex, tenantId, pgSize)),
    cancelNotificationTask: (taskId, cb) => dispatch(cancelNotificationTask(taskId, cb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationManagement);